<template>
  <div id="app" class="app">
    <router-view :key="id" />
    <toast-notification />
    <file-download-notification />
  </div>
</template>
<script>
import ToastNotification from '@/components/common/ToastNotification'
import FileDownloadNotification from '@/components/common/FileDownloadNotification'

export default {
  name: 'App',
  components: { ToastNotification, FileDownloadNotification },
  data() {
    return {
      id: this.$store.state.account.accountId
    }
  },
  methods: {
    showNetworkErrPopup({ code, msg }) {
      if (code) {
        return this.$notify({
          title: this.$t(`networkErrList.${code}`),
          text: `Status Code: ${code}`,
          type: 'error'
        })
      }
      return this.$notify({
        title: this.$t(`networkErrList.title`),
        text: this.$t(`networkErrList.defaultMsg`),
        type: 'error'
      })
    }
  },
  watch: {
    '$store.state.account.accountId'(newValue, oldValue) {
      if (parseInt(oldValue) !== newValue) {
        this.id = newValue
      }
    },
    '$store.state.api.err'(newValue, oldValue) {
      this.showNetworkErrPopup(this.$store.state.api.err)
    }
  }
}
</script>
